import { render, staticRenderFns } from "./AdditionalWarnings.vue?vue&type=template&id=63db792f"
import script from "./AdditionalWarnings.vue?vue&type=script&lang=js"
export * from "./AdditionalWarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports